export const kGoogleConstants = {
    scopes: ["https://www.googleapis.com/auth/gmail.modify", 
    "https://www.googleapis.com/auth/gmail.settings.basic", "profile", "email"],
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    redirectUri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
    baseUrl: process.env.REACT_APP_BASE_URL,
    authorizationEndpoint: "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: "https://www.googleapis.com/oauth2/v4/token",
    revocationEndpoint: "https://oauth2.googleapis.com/revoke",
}